import React, { Fragment, useState, useEffect } from 'react';
import { Button } from '@material-ui/core';
import { convertJiraStatus, usePostIssueTransition } from '../Jira.hooks';

export interface JiraStatusActionsProps {
  issue: any;
  onChange: (issue: any) => void;
}

export enum Transition {
  toDo,
  inProgress,
  done,
  inReview
}

interface TransitionSpec {
  id: number;
  name: string;
}
const getTransitionSpec = (status: Transition): TransitionSpec => {
  switch (status) {
    case Transition.toDo:
      return { id: 11, name: 'To Do' };
    case Transition.inProgress:
      return { id: 21, name: 'In Progress' };
    case Transition.done:
      return { id: 31, name: 'Done' };
    case Transition.inReview:
      return { id: 41, name: 'In Review' };
  }
};

const JiraStatusActions: React.FC<JiraStatusActionsProps> = ({
  issue,
  onChange
}) => {
  const issueId = issue.id ? issue.id : '';
  const initStatus = convertJiraStatus(issue.fields.status.name);
  const [status, setStatus] = useState(initStatus);
  const [, postIssueTransition] = usePostIssueTransition(issueId);

  useEffect(() => {
    setStatus(convertJiraStatus(issue.fields.status.name));
  }, [issue]);

  const handleTransition = (transition: Transition) => {
    const status = convertJiraStatus(getTransitionSpec(transition).name);
    onChange(status);
    setStatus(status);
    postIssueTransition({
      transition: { id: getTransitionSpec(transition).id }
    });
  };
  console.log('status:', status);
  switch (status) {
    case 'to-do':
      return (
        <Fragment>
          <Button
            variant='contained'
            color='primary'
            onClick={() => handleTransition(Transition.inProgress)}
          >
            Start Draft
          </Button>
        </Fragment>
      );
    case 'in-progress':
      return (
        <Fragment>
          <Button
            variant='outlined'
            color='secondary'
            onClick={() => handleTransition(Transition.toDo)}
          >
            Undo Draft
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => handleTransition(Transition.inReview)}
          >
            Submit for Review
          </Button>
        </Fragment>
      );
    case 'in-review':
      return (
        <Fragment>
          <Button
            variant='outlined'
            color='secondary'
            onClick={() => handleTransition(Transition.inProgress)}
          >
            Back to Draft
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => handleTransition(Transition.done)}
          >
            Approve
          </Button>
        </Fragment>
      );
    default:
      return null;
  }
};

export default JiraStatusActions;
